import { useQuery } from '@tanstack/react-query';
import { getDocumentSections } from '../api/index';

export const useDocumentSections = () => {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: ['adminLocalizationApi.getDocumentSections'],
    queryFn: getDocumentSections,
    select: (res) => res.data
  });

  return {
    isLoading,
    isError,
    data,
    error
  };
};
